<template>
    <div>
        <OpportunityPageButtons
            :id="skill.id"
            fixed-on-mobile
            :org-name="org.title"
            :org-type="org.type"
            :title="skill.title"
            type="skill"
        >
            <ApplyForSkillButton :org="org" :skill="skill" />
        </OpportunityPageButtons>

        <CoursePlayer v-if="hasCurriculum" :skill="skill" />

        <div v-if="showSkillContent" class="mb-20 grid gap-8 md:grid-cols-3">
            <div v-if="skill.contentURL" :class="[skill.slido && showSlido ? 'md:col-span-2' : 'md:col-span-3']">
                <CEmbedVideo :src="videoUrl" :track-data="trackData" />
            </div>

            <div v-if="skill.slido && showSlido" :class="{ 'md:col-span-3': !skill.contentURL }">
                <CookieIframe
                    frameborder="0"
                    height="490"
                    :src="'https://app.sli.do/event/' + skill.slido"
                    width="100%"
                ></CookieIframe>
            </div>

            <div v-if="skill.recordingURL" class="md:col-span-3">
                <CHeading variant="2"> Záznam </CHeading>
                <div>
                    <CEmbedVideo :src="recordingUrl" :track-data="trackData" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getEmbededRecording, getEmbededVideo } from '#shared/media'
import { parseDate } from '#shared/utils'
import type { Skill, SkillOrgPreview } from '#shared/types/Skill'
import { SkillType } from '#shared/types/Skill'
import { hasLessonContent } from '#shared/utils/course'
import CoursePlayer from '@/components/skills/CoursePlayer.vue'

interface Props {
    skill: Skill
    org: SkillOrgPreview
}

interface SkillVideoTrack {
    videoType: string
    recordingType: string
    oppType: string
    oppName: string
    oppOrg: string
    oppId: string | 'static'
}

const props = defineProps<Props>()
const hasCurriculum = computed(() => props.skill.type === SkillType.kurz && props.skill.lessons?.some((lesson) => lesson.title?.trim() && hasLessonContent(lesson)))

const showSkillContent = computed((): boolean => {
    return !!props.skill.contentURL || !!props.skill.recordingURL || (!!props.skill.slido && !!showSlido.value)
})

const videoUrl = computed((): string => {
    return getEmbededVideo(props.skill)
})

const recordingUrl = computed((): string => {
    return getEmbededRecording(props.skill)
})

const showSlido = computed((): boolean => {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 100)
    return parseDate(props.skill.startDate).getTime() < tomorrow.getTime()
})

const trackData = computed((): SkillVideoTrack => {
    return {
        videoType: props.skill.contentURLType,
        recordingType: props.skill.recordingURLType,
        oppType: 'skill',
        oppName: props.skill.title,
        oppOrg: props.org.title,
        oppId: props.skill.id
    }
})
</script>
